(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-collapsible"] && !window.DesignMode) return;
  try {
    
  const firstbutton = document.querySelector('.question-button');
  if (firstbutton) {
    const idPrimaryTheme = firstbutton.getAttribute('data-id');
    showQuestions(idPrimaryTheme);
    firstbutton.classList.add('twcss-text-amber-500');
  }

  const buttonsQuestion = document.querySelectorAll('.question-button');

  buttonsQuestion.forEach(function (button) {
    button.addEventListener('click', function () {
      const idTheme = this.getAttribute('data-id');
      closeAllQuestions();
      showQuestions(idTheme);
      buttonsQuestion.forEach(function (button) {
        button.classList.remove('twcss-text-amber-500');
      });
      this.classList.add('twcss-text-amber-500');
    });
  });

  function closeAllQuestions() {
    const QuestionsAnswers = document.querySelectorAll('.topic-questions');
    QuestionsAnswers.forEach(function (item) {
      item.style.display = 'none';
    });
  }

  function showQuestions(id) {
    var QuestionsAnswersTheme = document.querySelectorAll('.topic-questions[data-tema="' + id + '"]');

    QuestionsAnswersTheme.forEach(function (item) {
      item.style.display = 'none';
    });

    var questionShow = document.getElementById(id);

    var allHidden = true;
    QuestionsAnswersTheme.forEach(function (item) {
      if (item.style.display === 'block') {
        allHidden = false;
      }
    });

    if (allHidden && QuestionsAnswersTheme.length > 0) {
      QuestionsAnswersTheme[0].style.display = 'block';
    } else {
      questionShow.style.display = 'block';
    }
  }

  function verifyTopicOpen() {
    const openTheme = document.querySelector('.topic-questions[style="display: block;"]');
    return openTheme === null;
  }
  function reloadPageYesNoTopicOpen() {
    if (verifyTopicOpen()) {
      location.reload();
    }
  }

  setInterval(reloadPageYesNoTopicOpen, 5000);

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-team"] && !window.DesignMode) return;
  try {
    
  var slider = document.getElementById('slider');
  var slides = Array.from(slider.getElementsByClassName('slide'));
  var index = 0;
  var slideWidth = slides[0].offsetWidth;

  function updateOpacity() {
    slides.forEach(function (slide, i) {
      if (
        slider.scrollLeft + slider.offsetWidth > i * slideWidth &&
        slider.scrollLeft + slider.offsetWidth <= (i + 1) * slideWidth
      ) {
        slide.classList.add('fade-out');
      } else {
        slide.classList.remove('fade-out');
      }
    });
  }

  updateOpacity(); // Llama a la función inmediatamente después de definirla

  slider.addEventListener('scroll', updateOpacity);

  setInterval(function () {
    slider.scrollLeft = slideWidth * index;
    index++;
    if (index >= slides.length) {
      index = 0;
      slider.scrollLeft = 0;
    }
    updateOpacity();
  }, 3000);

  window.prevSlideDekstop = function () {
    index--;
    if (index < 0) {
      index = slides.length - 1;
    }
    slider.scrollLeft = slideWidth * index;
    updateOpacity();
  };

  window.nextSlideDekstop = function () {
    index++;
    if (index >= slides.length) {
      index = 0;
    }
    slider.scrollLeft = slideWidth * index;
    updateOpacity();
  };

  } catch(e) { console.error(e); }
})();
      })();
